module.exports = __webpack_public_path__ + "media/images/sp/top/google_review@2x-d8abc4970e4bcbcad7989cdc989ee507.webp";